import { render, staticRenderFns } from "./ConsultationStart.vue?vue&type=template&id=8714e678&scoped=true&"
import script from "./ConsultationStart.vue?vue&type=script&lang=js&"
export * from "./ConsultationStart.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationStart.vue?vue&type=style&index=0&id=8714e678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8714e678",
  null
  
)

export default component.exports